import { UserRole, UserRoles } from '../types/user-role.type';

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  [UserRoles.SUPER_ADMIN]: 'Super Admin',
  [UserRoles.ADMIN]: 'Admin',
  [UserRoles.ECO]: 'Éco-acteur',
  [UserRoles.USER]: 'Utilisateur',
  [UserRoles.SUBSCRIBER_BTOB]: 'Abonné B2B',
  [UserRoles.SUBSCRIBER_BTOC]: 'Abonné B2C',
  [UserRoles.CONCIERGERIE]: 'Conciergerie',
  [UserRoles.CONTACT]: 'Contact',
  [UserRoles.ENTREPRISE]: 'Entreprise',
};
